import styles from '../styles/Button.module.scss';
import { useSound } from '../context/SoundContext';
import React, { useState, PointerEvent } from "react";
const base = process.env.PUBLIC_URL || ``;

interface ButtonProps {
    label: string;
    redColor: boolean;
    answered: boolean;
    onClick: () => void;
    width?: string | undefined;
    canDisabled?: boolean;
    startInvisible?: boolean;
    patient?: string;
    page?: number;
    currentPage?: number;
    veryRedColor?: boolean;
    greenColor?: boolean;
}

const Button: React.FC<ButtonProps> = ({
                                           label,
                                           redColor,
                                           answered,
                                           onClick,
                                           width,
                                           canDisabled = false,
                                           startInvisible,
                                           patient = '',
                                           page,
                                           currentPage = 1,
                                           veryRedColor = false,
                                           greenColor = false,
                                       }) =>  {

    // @ts-ignore
    const { muted, toggleMuted } = useSound();

    const [pressed, setPressed] = useState(false);

    const handlePointerDown = (e: PointerEvent<HTMLDivElement>) => {
        // только основной указатель, левая кнопка (для мыши)
        if (!e.isPrimary) return;
        setPressed(true);
    };

    const handlePointerUp = () => {
        setPressed(false);
    };

    const handlePointerCancel = () => {
        setPressed(false);
    };

    const handlePointerLeave = () => {
        setPressed(false);
    };

    if (currentPage !== page && page) {
        return null;
    }

    let baseClass =
        !answered
            ? (!redColor ? styles.Button : styles.RedButton)
            : (canDisabled ? styles.AnsweredButton : styles.Button);

    if (veryRedColor) {
        baseClass = styles.VeryRedButton
    }
    if (greenColor) {
        baseClass = styles.GreenButton
    }

    const className = [
        baseClass,
        pressed ? styles.Pressed : '',
    ].join(' ').trim();

    return (
        <div
            className={className}
            onClick={onClick}
            onPointerDown={handlePointerDown}
            onPointerUp={handlePointerUp}
            onPointerCancel={handlePointerCancel}
            onPointerLeave={handlePointerLeave}
            style={{
                whiteSpace: "pre-line",
                ...(width && { width }),
                ...(startInvisible && { display: "none" }),
            }}
        >
            {(label !== 'arrow_prev' && label !== 'arrow_next') ? (
                label
            ) : (
                <>
                    {label === 'arrow_prev' ? (
                        <img src={`${base}/images/button_prev.svg`} />
                    ) : (
                        <img src={`${base}/images/button_next.svg`} />
                    )}
                </>
            )}
        </div>
    );
};

export default Button;
